import React from 'react';
import { ToastContainer, cssTransition } from 'react-toastify';
import { useScreenLargerThan } from '../hooks/breakpoint-hooks';

const FadeRight = cssTransition({
    enter: 'animate__animated animate__fadeInRight',
    exit: 'animate__animated animate__fadeOutRight'
});

const FadeUp = cssTransition({
    enter: 'animate__animated animate__fadeInUp',
    exit: 'animate__animated animate__fadeOutUp'
});

const ToastProvider = () => {
    const isLargerThanSmall = useScreenLargerThan('sm');
    return (
        <ToastContainer
            position={isLargerThanSmall ? 'top-right' : 'bottom-center'}
            autoClose={3000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            transition={isLargerThanSmall ? FadeRight : FadeUp}
            limit={isLargerThanSmall ? 5 : 2}
            theme="colored"
        />
    );
};

export default ToastProvider;
